import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { KanbanOfferStore } from './kanban-offer.store';

@Injectable()
export class KanbanOfferStoreList {
  public list: KanbanOfferStore[];
  public notfullfill: KanbanOfferStore;
  constructor() {
    //this.loadInitialData(1);
  }

  onDestroy(){
      this.list.forEach(element => {
        element.ngOnDestroy();
      });
      this.notfullfill.ngOnDestroy();
  }

  getTotalAppliers(statusID){
    this.list.forEach(element => {
      if (element.statusID === statusID){

      }
    });
    this.notfullfill.ngOnDestroy();
}

  restore(){
    if(this.list){
      this.list.forEach(element => {
        element.restore();
      });
      this.notfullfill.restore();
    }
  }

  refresh(){
    if(this.list){
      this.list.forEach(element => {
        element.refresh();
      });
      this.notfullfill.refresh();
    }
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/state/kanban-offer-list.store.ts